import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary 강의 자료 삭제
 */
export const deleteCourseAsset = (
    courseId: string,
    assetId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `https://api.ugot.uk/api/courses/${courseId}/assets/${assetId}`,options
    );
  }



export const getDeleteCourseAssetMutationOptions = <TError = AxiosError<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseAsset>>, TError,{courseId: string;assetId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCourseAsset>>, TError,{courseId: string;assetId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourseAsset>>, {courseId: string;assetId: string}> = (props) => {
          const {courseId,assetId} = props ?? {};

          return  deleteCourseAsset(courseId,assetId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCourseAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourseAsset>>>
    
    export type DeleteCourseAssetMutationError = AxiosError<void>

    /**
 * @summary 강의 자료 삭제
 */
export const useDeleteCourseAsset = <TError = AxiosError<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseAsset>>, TError,{courseId: string;assetId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCourseAsset>>,
        TError,
        {courseId: string;assetId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCourseAssetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    